import { React } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
} from '@material-ui/core';
// import { scroller } from "react-scroll";
import { Helmet } from 'react-helmet';

import { METADATA } from '../../constants';
import Navbar from '../../components/HomeComponents/Navbar'
import Footer from '../../components/HomeComponents/Footer'
// import SectionOne from '../../components/HomeComponents/Sections/SectionOne'
// import SectionTwo from '../../components/HomeComponents/Sections/SectionTwo'
// import SectionThree from '../../components/HomeComponents/Sections/SectionThree'
import SectionFour from '../../components/HomeComponents/Sections/SectionFour'
import SectionFive from '../../components/HomeComponents/Sections/SectionFive'
import SectionSix from '../../components/HomeComponents/Sections/SectionSix'
import SectionSeven from '../../components/HomeComponents/Sections/SectionSeven'
import SectionEight from '../../components/HomeComponents/Sections/SectionEight'
import SectionNine from '../../components/HomeComponents/Sections/SectionNine'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: 60
  },
  sectionOne: {
    height: "500px",
    backgroundColor: "#e1eff6",
  },
}));



export default function Home() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Helmet>
        <meta name="description" content={METADATA.LYDBRANDING.description} />
        <title>{METADATA.LYDBRANDING.title}</title>
      </Helmet>
      <Navbar/>
      <SectionFour/>
      <SectionFive />
      <SectionSix />
      <SectionSeven />
      <SectionEight />
      <SectionNine />

      <Footer />
    </div>
  )
}